import EconomicTerminalPage from '@/modules/economic-terminal/economic-terminal-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_dashboard/dashboard/economic-terminal/',
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <EconomicTerminalPage />;
}
